import {Boot} from '@/project'
import VueProgressBar from 'vue-progressbar'

declare module 'vue/types/vue' {
  interface Vue {
    readonly $Progress: any
  }
}

/**
 * show progressing between starting and ending ajax request
 * used by /src/layout/Index.vue with src/lib/high-jack-ajax
 * @param Vue
 */
const boot: Boot = ({Vue}) => {
  Vue.use(VueProgressBar, {
    color: '#1F75E8',
    thickness: '4px'
  })
}

export default boot
